module.exports = __webpack_public_path__ + "img/phone1.bca6503a.png";